var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59961 3.0182C1.59961 2.44098 1.80232 1.96479 2.20772 1.58963C2.61312 1.21444 3.14016 1.02686 3.7888 1.02686C4.42587 1.02686 4.9413 1.21155 5.33513 1.58097C5.74053 1.96192 5.94324 2.4583 5.94324 3.07014C5.94324 3.62426 5.74633 4.08601 5.3525 4.45543C4.94711 4.83638 4.41428 5.02685 3.75405 5.02685H3.73668C3.0996 5.02685 2.58417 4.83638 2.19034 4.45543C1.79651 4.07447 1.59961 3.59539 1.59961 3.0182ZM1.82548 18.1697V6.60261H5.68262V18.1697H1.82548ZM7.81969 18.1697H11.6768V11.7108C11.6768 11.3068 11.7232 10.9951 11.8158 10.7758C11.978 10.3833 12.2241 10.0514 12.5542 9.7801C12.8844 9.50881 13.2984 9.37317 13.7965 9.37317C15.0938 9.37317 15.7425 10.2447 15.7425 11.9879V18.1697H19.5996V11.5377C19.5996 9.82915 19.1942 8.53335 18.3834 7.65023C17.5726 6.76711 16.5012 6.32555 15.1691 6.32555C13.6749 6.32555 12.5108 6.96625 11.6768 8.24763V8.28226H11.6595L11.6768 8.24763V6.60261H7.81969C7.84285 6.97201 7.85444 8.12064 7.85444 10.0485C7.85444 11.9763 7.84285 14.6834 7.81969 18.1697Z",
    fill: "#064E3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.5aa09cbc532f1b77d009ee76596fbea2.svg";
export { ForwardRef as ReactComponent };